'use strict'

import React from 'react'
import $     from 'jquery'

export default class FindPage extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      practices: [],
      more: true,
      where: '4000'
    }

    this.location = ''
    this.page = 1
  }

  select (name, slug) {
    this.props.onChange('dentist', {
      displayName: 'Dentist',
      value: name,
      pageRef: 'your-preference',
      order: 2,
      slug: slug,
      displayInSummary: true
    })

    window.ga('send', 'event', {
      eventCategory: 'Find a Dentist',
      eventAction: 'Click',
      eventLabel: 'Select & Apply'
    })

    this.props.showSecondForm()
  }

  getPractices (page, where) {
    where = typeof where === 'string' ? where : this.state.where

    if (where < 4) return

    $.ajax({
      url: '/find-a-dentist',
      type: 'GET',
      headers: {
        Accept: 'application/json'
      },
      dataType: 'json',
      data: {
        location: where + ', Australia',
        per: 5,
        page: page,
        radius: 10000
      },
      success: (data) => {
        let newPractices = page !== 1 ? this.state.practices : []

        for (let i in data) {
          let practice = data[i].practice

          newPractices.push({
            name: practice.name,
            address: practice.address,
            slug: practice.slug
          })
        }

        this.setState({
          practices: newPractices,
          more: !(newPractices.length < 5)
        })
      },
      error: () => {
        this.refs.wrapper.innerHTML = '<h3>Something went wrong.</h3>'
      }
    })
  }

  searchClick (e) {
    this.getPractices(this.page = 1)
  }

  validate (e) {
    this.setState({
      where: (e.target.value = e.target.value.substring(0, 4).replace(/[^0-9]/, ''))
    })
  }

  componentDidMount () {
    this.getPractices(1, '4000')
    window.fbq('track', 'ViewContent')

    window.ga('send', {
      hitType: 'pageview',
      page: 'Find a Dentist'
    })
  }

  focus () {
    window.ga('send', 'event', {
      eventCategory: 'Find a Dentist',
      eventAction: 'Interaction',
      eventLabel: 'Post Code'
    })
  }

  render () {
    return (
      <div className='box findbox'>
        <h2>Find a Dentist</h2>
        <div>
          <input
            onChange={this.validate.bind(this)}
            onFocus={this.focus.bind(this)}
            onKeyUp={this.searchClick.bind(this)}
            placeholder='Search by Post Code'
            ref='findinput'
            type='text' />
          <div onClick={this.searchClick.bind(this)} className='findbox-button'>
            <svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'>
              <path fill='#000' d='M15.56 15.56c-0.587 0.587-1.538 0.587-2.125 0l-2.652-2.652c-1.090 0.699-2.379
                                              1.116-3.771 1.116-3.872 0-7.012-3.139-7.012-7.012s3.14-7.012 7.012-7.012c3.873
                                              0 7.012 3.139 7.012 7.012 0 1.391-0.417 2.68-1.116 3.771l2.652 2.652c0.587 0.587
                                              0.587 1.538 0 2.125zM7.012 2.003c-2.766 0-5.009 2.242-5.009 5.009s2.243 5.009
                                              5.009 5.009c2.766 0 5.009-2.242 5.009-5.009s-2.242-5.009-5.009-5.009z'>
              </path>
            </svg>
          </div>
        </div>
        <div ref='wrapper' className='findbox-wrapper'>
          {this.state.practices.length ? (
            <div>
              {this.state.practices.map((practice, i) => {
                return (
                  <div onClick={this.select.bind(this, practice.name, practice.slug)} key={i} className='findbox-item'>
                    <h4>{practice.name}</h4>
                    <span>{practice.address}</span>
                    <div>
                      Select & Apply
                    </div>
                  </div>
                )
              })}
              {this.state.more && <span className='findbox-more' onClick={this.getPractices.bind(this, ++this.page)}>more</span>}
            </div>)
            : <div>
              {this.page ? 'No results found.' : ''}
            </div>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/find-page.js